export const authConstants = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGOUT: 'USERS_LOGOUT',

    FETCH_STATE_STORAGE_SUCCESS: 'FETCH_STATE_STORAGE_SUCCESS',
    FETCH_STATE_STORAGE_ERROR: 'FETCH_STATE_STORAGE_ERROR',
    FETCH_STATE_STORAGE_REQUEST: 'FETCH_STATE_STORAGE_REQUEST',

    token: {
        INVALID_TOKEN: 'INVALID_TOKEN',
        REFRESHING_TOKEN: 'REFRESHING_TOKEN',
        TOKEN_REFRESHED: 'TOKEN_REFRESHED',
        RESEND_TOKEN: 'RESEND_TOKEN',
        REFRESH_EXPIRED: 'REFRESH_EXPIRED',
    },
};
